import { Tab, Tabs, Box } from '@mui/material';
import { DEMAND_OVERVIEW_TABS } from '../enums/demandOverview';

function DemandOverviewTabs({ activeTabId, onTabChange }) {
  const renderTabIcon = iconPath => {
    if (!iconPath) return null;
    return (
      <Box
        component="img"
        src={iconPath}
        alt="tab-icon"
        className="sas-tab-icon"
      />
    );
  };

  return (
    <Tabs
      value={activeTabId}
      onChange={onTabChange}
      variant="fullWidth"
      className="sas-tabs"
      sx={{
        '& .MuiTab-root': {
          minHeight: 42,
          color: 'text.secondary',
          textTransform: 'none',
        },
        '& .Mui-selected': {
          color: 'primary.main',
        },
        '& .MuiTabs-indicator': {
          height: 3,
          bgcolor: 'primary.main',
        },
      }}>
      {DEMAND_OVERVIEW_TABS.map(tab => {
        const isActive = activeTabId === tab.id;
        const iconPath = isActive ? tab.activeIconPath : tab.inactiveIconPath;

        return (
          <Tab
            key={tab.id}
            icon={renderTabIcon(iconPath)}
            iconPosition="start"
            label={tab.label}
            value={tab.id}
          />
        );
      })}
    </Tabs>
  );
}

export default DemandOverviewTabs;
